import { callRequest } from '../../helpers/callRequest';
import { autofillParams } from './autofillParams';
export const getUseWrappedMutationWithAxiosConfig = ({ request, getAutofill, getUseMutation, }) => {
    const useMutation = getUseMutation();
    const mutationFn = ({ variables, axiosConfig }) => {
        const autofileedParams = autofillParams(variables, getAutofill);
        return callRequest(request, autofileedParams, axiosConfig);
    };
    const useWrappedMutation = (mutationOptions) => {
        return useMutation({
            mutationFn,
            ...mutationOptions,
        });
    };
    return useWrappedMutation;
};
